/**
 * Shared mesh-import format definitions used by the import pipeline and UI.
 */

export const MESH_IMPORT_EXTENSIONS = [
  ".obj",
  ".glb",
  ".gltf",
  ".fbx",
] as const;

export type MeshSourceFormat = "obj" | "glb" | "gltf" | "fbx";

export const MESH_IMPORT_ACCEPT = MESH_IMPORT_EXTENSIONS.join(",");
export const MESH_IMPORT_DISPLAY = MESH_IMPORT_EXTENSIONS.join("/");

export function meshSourceFormatFromFileName(
  fileName: string,
): MeshSourceFormat {
  const lower = fileName.toLowerCase();
  if (lower.endsWith(".obj")) return "obj";
  if (lower.endsWith(".glb")) return "glb";
  if (lower.endsWith(".gltf")) return "gltf";
  if (lower.endsWith(".fbx")) return "fbx";
  throw new Error(`Unsupported mesh import format: ${fileName}`);
}

export function isMeshImportFileName(fileName: string): boolean {
  try {
    meshSourceFormatFromFileName(fileName);
    return true;
  } catch {
    return false;
  }
}

export function stripMeshImportExtension(fileName: string): string {
  return fileName.replace(/\.(obj|glb|gltf|fbx)$/i, "");
}
